import * as React from 'react';

import './style.scss';

import {P} from 'components/atoms/Text/P';
import {Container} from 'components/atoms/Layout/Container';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';
import {Headline} from '@atoms/Text/Headline';
import {HeadlineLevel} from 'features/ui/enums';

interface Props {
    headline?: string;
    children?: React.ReactNode;
    link?: string;
    linkText?: string;
}

export const InfoMessage: React.FunctionComponent<Props> = ({headline, children, link, linkText}) => {
    return (
        <div className="info-message">
            <Container narrow>
                {headline && <Headline level={HeadlineLevel.H3} darkBg>{headline}</Headline>}
                {children}
                {link && linkText &&
                    <P>
                        <ButtonLink 
                            href={link} 
                            buttonColor={ButtonColor.LIGHT} 
                            buttonSize={ButtonSize.DEFAULT} 
                            buttonType={ButtonType.GHOST} 
                        >
                            {linkText}
                        </ButtonLink>
                    </P>
                }
            </Container>
        </div>
    )
};
